import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { Accordion, Bullet, Hairline, HeaderThree } from 'secondstep-components'
import AdminLessonProgressTabs from 'components/AdminLessonProgressTabs'

const breakpoints = {
  customMedium: '@media screen and (max-width: 1050px)',
  customTablet: '@media screen and (max-width: 860px)',
}

export const BodyWrapper = styled.div.attrs(({ classesCreated }) => ({
  padding: classesCreated === 0 ? '0' : '0.875rem 1.25rem 1.75rem',
  alignItems: classesCreated === 0 ? 'center' : 'inherit',
}))`
  align-items: ${({ alignItems }) => alignItems};
  background-color: ${themeGet('colors.linkLight')};
  border: 2px solid ${themeGet('colors.paleGray')};
  border-radius: 0.625rem;
  padding: ${({ padding }) => padding};

  ${themeGet('breakpoints.mobile')} {
    padding-bottom: 0.3125rem;
  }
`

export const ClassesProgressWrapper = styled.div`
  width: 200px;
  min-width: 145px;
  color: ${themeGet('colors.darkGray')};
  font-size: 1rem;
  padding-top: 0.1875rem;
  padding-left: 1rem;
  padding-right: 1.25rem;
  line-height: 1.375rem;
`

export const ClassProgressBullet = styled(Bullet)`
  background-color: ${themeGet('colors.yellow')};
  transform: translateY(0.0625rem);
`

export const ClassesNotStartedText = styled.span`
  font-family: ${themeGet('fontFamily')};
`

export const ClassesNotStartedWrapper = styled.div``

export const ClassesStartedText = styled.span`
  font-family: ${themeGet('fontFamilySemibold')};
`

export const GoalTextClasses = styled.span`
  font-family: ${themeGet('font.molde.regular')};
`

export const LessonCompletionWrapper = styled.div.attrs(
  ({ classesCreated }) => ({
    opacity: classesCreated === 0 ? '50%' : 'inherit',
  }),
)`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 300px;
  opacity: ${({ opacity }) => opacity};
  padding-top: 0.125rem;

  color: ${themeGet('colors.darkGray')};
  font-family: ${themeGet('fontFamilySemibold')};
  font-size: 1rem;

  [class*='Background'] {
    background-color: ${themeGet('colors.linkLight')};
    height: 0.75rem;
    margin-top: 0;
    max-width: 9.25rem;
  }

  [class*='Indicator'] {
    height: 0.75rem;
  }

  [class*='ProgressOutsideBar'] {
    padding-top: 0.0875rem;
  }

  [class*='Wrapper'] {
    width: 100%;
    max-width: 170px;
    align-items: center;
    padding-bottom: 0.0625rem;
  }
`

export const NoClassesMessage = styled.span`
  font-family: ${themeGet('fontFamilySemibold')};
`

export const PanelWrapper = styled.div`
  display: flex;
  direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export const PipeSeparator = styled.span`
  margin: 0 0.5rem;
  font-family: ${themeGet('font.molde.regular')};
`

export const SiteCollapsible = styled(Accordion).attrs(
  ({ classesNotStarted, dataTestId }) => ({
    padding:
      classesNotStarted === 0
        ? '0.9125rem 0.25rem 0.9125rem 1.125rem'
        : '0.6875rem 0.25rem 0.6875rem 1.125rem',
    'data-testid': dataTestId,
  }),
)`
  width: 100%;
  border: 2px solid
    ${themeGet('colors.backgrounds.secondary', 'colors.paleGray')};
  background: ${themeGet('colors.paleGray')};

  &:hover {
    outline: 2px solid ${themeGet('colors.grayBlue')};
  }

  svg {
    color: ${themeGet('colors.blue')};
    margin-right: 0;
  }

  [class*='AccordionPanel'] {
    padding: ${({ padding }) => padding};
    background: ${themeGet('colors.paleGray')};

    ${breakpoints.customTablet} {
      padding: 0.875rem 1.125rem;
    }

    &:hover {
      svg {
        color: ${themeGet('colors.darkBlue')};
      }
    }
  }

  [class*='AccordionTitleWrapper'] {
    width: 100%;
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
  }

  [class*='AccordionTitle'] {
    width: 100%;
    margin-right: 0;
  }

  [class*='AccordionContentWrapper'] {
    width: 100%;
    margin: 0;
    overflow: visible;
    [class*='AccordionContent'] {
      padding: 0 1rem 1.25rem 1rem;
      background: ${themeGet('colors.paleGray')};
    }
  }

  [class*='StyledCaret'] {
    &:hover {
      color: ${themeGet('colors.darkBlue')};
    }
  }
`

export const StyledAdminLessonProgressTabs = styled(AdminLessonProgressTabs)`
  margin: 0.8125rem 0 0.75rem;

  ${breakpoints.customTablet} {
    margin: 0 0 0.5rem;
  }
`

export const StyledHairline = styled(Hairline)`
  color: ${themeGet('colors.paleGray')};
  height: 0.125rem;
  margin: 1.75rem 0 1.4375rem;
  opacity: 0.5;
  width: unset;

  ${themeGet('breakpoints.mobile')} {
    margin: 1.25rem 0 0.9375rem;
  }
`

export const StyledHeader = styled(HeaderThree)`
  font-size: 1.125rem;
  font-family: ${themeGet('fontFamilySemibold')};
  width: 40%;
  margin-bottom: 0;
  padding-top: 0.125rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const CardHeading = styled.p`
  width: 34.188rem;
  color: #555555;
  font-family: ${themeGet('font.molde.medium')};
  font-size: 1.125rem;
  font-weight: 500;
  letter-spacing: 0.013rem;
  line-height: 2.35rem;
`
